import {IMainScreenService} from './main-screen.service.interface';
import {observable, action} from 'mobx';
import {ServiceBase} from '../ServiceBase';
import {DomEventSubscription, EventListenerRegistration} from '../../../utils/event-listener-registration';

export class MainScreenService extends ServiceBase implements IMainScreenService {

	_scrollEventSubscription: DomEventSubscription = null;

	private _eventListenerRegistration: EventListenerRegistration;

	get subscribeTo(): EventListenerRegistration {
	  return this._eventListenerRegistration;
	}
	
    @action.bound
    setMainScreenElement(element: HTMLElement): void {
        this.services.window.setScrollContainer(element);

        if(this._scrollEventSubscription) {
            this._scrollEventSubscription.dispose();
			this._scrollEventSubscription = null;
		}
		
        this.mainScreenElement = element;
        if(this.mainScreenElement) {
			this._eventListenerRegistration = new EventListenerRegistration(element);
            this.mainScreenElement.addEventListener('scroll', this._scrollHandler);
            this._scrollEventSubscription = {
                dispose: () => element.removeEventListener('scroll', this._scrollHandler)
            }
        }

    }

    private _scrollHandler = () => {
        window.dispatchEvent(new Event('scroll'));
    };

    @observable.ref mainScreenElement: HTMLElement;

}